import { render, staticRenderFns } from "./facilitiesAndServices.vue?vue&type=template&id=7e1e2863&scoped=true&"
import script from "./facilitiesAndServices.vue?vue&type=script&lang=js&"
export * from "./facilitiesAndServices.vue?vue&type=script&lang=js&"
import style0 from "./facilitiesAndServices.vue?vue&type=style&index=0&id=7e1e2863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1e2863",
  null
  
)

export default component.exports